import { render, staticRenderFns } from "./InfoSection.htm?vue&type=template&id=3eb36be4&scoped=true&"
import script from "./InfoSection.ts?vue&type=script&lang=js&"
export * from "./InfoSection.ts?vue&type=script&lang=js&"
import style0 from "./InfoSection.scss?vue&type=style&index=0&id=3eb36be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb36be4",
  null
  
)

export default component.exports